import { FadeIn } from "@/components/Reveal";
import ChapterHeader from "@/components/ChapterHeader";
import UploadedPhotos from "@/components/UploadedPhotos";
import { useCategoryPhotos, pickPhoto } from "@/lib/usePhotos";

export default function Heritage() {
  const heritagePhotos = useCategoryPhotos("heritage");
  const lodgeImg = pickPhoto(heritagePhotos, 0);
  const buddhistImg = pickPhoto(heritagePhotos, 1);
  return (
    <main data-testid="heritage-page" className="pt-32 pb-24">
      <section className="mx-auto max-w-[1600px] px-6 lg:px-12">
        <FadeIn>
          <div className="stamp mb-8">Vol · I · The Estate</div>
          <h1 className="font-display text-6xl md:text-8xl leading-[0.95] text-[#F2E7D0] max-w-5xl">
            A working farm since the mid-<em className="italic text-[#D97645]">1930's</em>.
          </h1>
        </FadeIn>
      </section>

      <section className="mx-auto max-w-[1600px] px-6 lg:px-12 py-24 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <FadeIn className="lg:col-span-6">
          <div className="w-full aspect-[4/5] bg-[#27221C] overflow-hidden">
            {lodgeImg && <img src={lodgeImg} alt="Heritage home" className="w-full h-full object-cover vintage-img" />}
          </div>
        </FadeIn>
        <FadeIn delay={0.15} className="lg:col-span-6 flex flex-col justify-center">
          <ChapterHeader num="01" kicker="The Lodge" title="The British hunting lodge." />
          <p className="text-[#B8A891] leading-relaxed text-lg">
            The heritage home was built as a British hunting lodge with a working fireplace.
            Indian and Continental cuisine has been served here from the mid-1930's onwards, and
            continues without interruption to this day.
          </p>
        </FadeIn>
      </section>

      <section className="bg-[#27221C] py-24">
        <div className="mx-auto max-w-[1600px] px-6 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12">
          <FadeIn className="lg:col-span-6 order-2 lg:order-1 flex flex-col justify-center">
            <ChapterHeader num="02" kicker="Buddhist Block" title="Ranchi's first Buddhist-tradition residential block." />
            <p className="text-[#B8A891] leading-relaxed text-lg">
              A contemporary counterpoint to the lodge — the residential block is the first
              building of its kind in Ranchi, Jharkhand, built in true Buddhist tradition.
            </p>
          </FadeIn>
          <FadeIn delay={0.15} className="lg:col-span-6 order-1 lg:order-2">
            <div className="w-full aspect-[4/5] bg-[#27221C] overflow-hidden">
              {buddhistImg && <img src={buddhistImg} alt="Buddhist block" className="w-full h-full object-cover vintage-img" />}
            </div>
          </FadeIn>
        </div>
      </section>

      <UploadedPhotos category="heritage" kicker="Archive" title="Photographs from the estate archive." />
    </main>
  );
}
